var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5327_47511)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4029 1.24334C11.7351 0.918888 12.2656 0.918888 12.5977 1.24334L23.7431 12.1288C24.0809 12.4588 24.0873 13.0001 23.7574 13.3379C23.4274 13.6757 22.8861 13.6821 22.5483 13.3521L20.855 11.6983V22.1448C20.855 22.617 20.4722 22.9998 20 22.9998H4C3.5278 22.9998 3.145 22.617 3.145 22.1448V11.699L1.4524 13.3521C1.11459 13.6821 0.573272 13.6757 0.243335 13.3379C-0.0866015 13.0001 -0.0802164 12.4588 0.257597 12.1288L11.4029 1.24334ZM12.0003 3.05014L19.1455 10.0287C19.1452 10.0387 19.145 10.0487 19.145 10.0588V21.2898H12.855V15.0946C12.855 14.6224 12.4722 14.2396 12 14.2396C11.5278 14.2396 11.145 14.6224 11.145 15.0946V21.2898H4.855V10.0588C4.855 10.049 4.85483 10.0391 4.8545 10.0294L12.0003 3.05014Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5327_47511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.dba28f4a712f847938eebf4ebf742eeb.svg";
export { ForwardRef as ReactComponent };